var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hbox"},[_c('mu-icon',{attrs:{"value":"remove"},on:{"click":_vm.reduce}}),_vm._v(" "),_c('input',{staticClass:"myinput",attrs:{"type":"number"},domProps:{"value":_vm.currentValue},on:{"change":_vm.handleChange}}),_vm._v(" "),_c('mu-icon',{attrs:{"value":"add"},on:{"click":_vm.add}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ccb795","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumberInput.vue
// module id = null
// module chunks = 